import type { DailyReferenceDto } from "@/features/daily/types/daily.types";

type ReferenceLabel = DailyReferenceDto["label"];

/**
 * FR-015/SC-015: the mean of the past is an observation; a target is a decision.
 * This map is TOTAL over the closed vocabulary, so a historical reference can never
 * be presented as an objective the business set.
 */
const REFERENCE_TEXT: Record<ReferenceLabel, string> = {
    previous_period: "periodo anterior",
    previous_month: "mes anterior",
    historical_mean: "media histórica",
    target: "objetivo",
};

export const executiveViewModel = {
    referenceLabel: (label: ReferenceLabel): string => REFERENCE_TEXT[label],
};
